import { createFileRoute } from '@tanstack/react-router';
import { gallerySearchSchema } from '@/features/projects/model/gallerySearch';
import { ProjectsListPage } from '@/features/projects/ui/ProjectsListPage';

export const Route = createFileRoute('/_authenticated/projects/')({
  validateSearch: gallerySearchSchema,
  component: function ProjectsIndex() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    // replace: gõ ô tìm không đẻ một mục lịch sử mỗi phím; quay lại từ chi tiết về đúng URL đã lọc nhờ URL.
    return <ProjectsListPage search={search} navigateSearch={(next) => navigate({ search: next, replace: true })} />;
  },
});
